import React, { useEffect } from "react";
import '../assets/js/blog.js';

function AdminBlog() {
    useEffect(() => {
        if (window.loadBlogs) {
            window.loadBlogs();
        }
    }, []);

    return (
        <div>
            <h1 className="bg-warning p-3 ">Admin Blogs</h1>

            <section>
                <div className="p-2 d-flex justify-content-between align-items-center">
                    <h2>All Blogs</h2>
                    <a href="#" id='addBlog' class="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#blogModal">
                        <i class="fa-solid fa-plus"></i> Add
                    </a>
                </div>
                <div className="row px-lg-2">
                    <div className="col-12 overflow-scroll">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Sr No.</th>
                                    <th scope="col">Image</th>
                                    <th scope="col">Heading</th>
                                    <th scope="col">Sub Heading</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Title</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody id="allBlogData"></tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Blog Model */}
            <div class="modal fade" id="blogModal" tabindex="-1" aria-labelledby="blogModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content overflow-scroll">

                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title text-white" id="blogModalLabel">Add Blog</h5>
                            <button type="button" class="btn-close border border-0 text-white btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <form id="addBlogForm" enctype="multipart/form-data" class="p-3">
                            <div class="modal-body">
                                <div class="row g-3">

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Heading</b></label>
                                        <input type="text" name="heading" id="heading" class="form-control" required placeholder='enter heading' />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Sub Heading</b></label>
                                        <input type="text" name="subHeading" id="subHeading" class="form-control" required placeholder='enter sub heading' />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Title</b></label>
                                        <input type="text" name="title" id="title" class="form-control" required placeholder='enter title' />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label text-dark"><b>Description</b></label>
                                        <textarea class="form-control" placeholder="description here..." id="description" style={{ height: "100px" }}></textarea>
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label text-dark"><b>Blog Image</b></label>
                                        <input type="file" className="form-control" id="image" name="image" />
                                    </div>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn fw-semibold btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* Blog Model */}

            {/* Edit Blog Modal */}
            <div class="modal fade" id="editBlogModal" tabindex="-1">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content overflow-scroll">

                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title">Edit Blog</h5>
                            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <form id="editBlogForm" enctype="multipart/form-data" class="p-3">
                            <input type="hidden" id="editId" />

                            <div class="modal-body">
                                <div class="row g-3">

                                    <div class="col-md-6 mb-3">
                                        <label><b>Heading</b></label>
                                        <input type="text" id="editHeading" class="form-control" />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label><b>Sub Heading</b></label>
                                        <input type="text" id="editSubHeading" class="form-control" />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label><b>Title</b></label>
                                        <input type="text" id="editTitle" class="form-control" />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label><b>Description</b></label>
                                        <textarea id="editDescription" class="form-control" style={{ height: "100px" }}></textarea>
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label><b>Blog Image</b></label>
                                        <input type="file" id="editImage" class="form-control" />
                                    </div>

                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-primary">Update</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* ✅ Universal Success Modal */}
            <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content border-0 shadow-lg">

                        <div class="modal-header bg-success text-white">
                            <h5 class="modal-title fw-bold" id="successModalLabel">
                                <i class="bi bi-check-circle-fill me-2"></i> Success
                            </h5>
                            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
                            <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z" />
                            </svg>
                            <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
                        </div>

                        <div class="modal-footer border-0 justify-content-center">
                            <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    );
}

export default AdminBlog;
